import ZooPassFetch from "../Utilities/ZooPassFetch"

export default () => {

    const getMemberInfo = async () => {
        var data = await ZooPassFetch.fetchMemberInfo(window.baseApiUrl);
        return data;
    }
    
    const verifySession = async () => { 
        var data = await ZooPassFetch.isLoggedIn(window.baseApiUrl);

        if (data.validSession == false) {
            ZooPassFetch.redirectTNewSession(window.baseApiUrl);
        }
        
        return data.loggedIn;
    }

    return { getMemberInfo, verifySession };
}